// Development

// export const SERVER_URL = "https://vebbox.in/jaanu_backend";
// export const SERVER_PATH = `${SERVER_URL}/controllers/api/`;


// export const SERVER_URL = "http://localhost/healthybackend";
// export const SERVER_PATH = `${SERVER_URL}/controllers/api/`;


export const SERVER_URL = "https://janusfoodproducts.com/jaanu_backend";
export const SERVER_PATH = `${SERVER_URL}/controllers/api/`;

//  export const SERVER_URL = "http://localhost/jaanu_backend";
// export const SERVER_PATH = `${SERVER_URL}/controllers/api/`;

// export const SERVER_URL =
//   "https://srimangalambikastores.com/mangalambikastorebackend";
// export const SERVER_PATH = `${SERVER_URL}/controllers/api/`;